import { Component } from '@angular/core';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { APIUrl } from '../constant/api-call';
import { PERMISSION } from '../constant/permission';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import * as _ from 'underscore';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-project-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule],
  templateUrl: './project-dashboard.component.html',
  styleUrls: ['./project-dashboard.component.css']
})
export class ProjectDashboardComponent {
  public commonDataObject = {
    projects: [] as any[],
    selectedProjectId: [] as any[],
  }

  constructor(
    private router: Router,
    public projectService: ProjectService,
    private clientService: ClientService,
    private authService: AuthService,
  ) {
    setTimeout(() => {
      const storedProject = sessionStorage.getItem('selected_project');
      if (storedProject) {
        this.commonDataObject.selectedProjectId = JSON.parse(storedProject)?.project_id;
      }
    }, 500)
  }

  async ngOnInit() {
    await this.projectService.getMasterData();
  }

  onProjectClick(projectDetails: any) {
    this.commonDataObject.selectedProjectId = projectDetails?.project_id;
    this.projectService.setSelectedProject(projectDetails);
    this.router.navigate(['/project_details'], {
      queryParams: { id: projectDetails?.project_id }
    });
  }


  onReportClick(reportData: any) {
    this.projectService.setSelectedProject(reportData);
    setTimeout(() => {
      this.router.navigate(['form_reports']);
    }, 200);
  }


}
